<script>
import axios from 'axios';
import snackbarMixin from '@/mixins/snackbar';
import paginationMixin from '@/mixins/pagination';
import downloader from '@/mixins/downloader';
import RbxFileUpload from '@/shared/reybex/RbxFileUpload';

export default {
  name: 'CsvImportDialog',
  components: {
    RbxFileUpload,
  },
  mixins: [snackbarMixin, paginationMixin, downloader],
  data() {
    return {
      isFileProcessed: false,
      visible: false,
    };
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
    addFile() {
      this.isFileProcessed = true;
    },
    onUpload() {
      this.$emit('imported');
      this.close();
    },
    onError() {
      this.showErrorMessage('Die Datei konnte nicht importiert werden. Erlaubt sind nur Dateien, die der CSV-Vorlage entsprechen. Zeilenumbrüche sind nicht erlaubt.');
    },
    downloadCsvTemplate() {
      return axios.get('/affiliate/csvTemplate', {
        responseType: 'blob',
        timeout: 30000,
      }).then((response) => {
        this.getDownloadContent(response, 'Vertragspartner-Import-Vorlage.csv');
      }).catch(() => {
        this.showErrorMessage('Beim Herunterladen der Vorlage ist ein Fehler aufgetreten.');
      });
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        CSV-Import
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>

              <v-flex xs12 md12>
                Die Vertragspartner werden bei Auswahl der Datei direkt importiert.
                Wenn Sie Rückmeldung über das Import-Ergebnis erhalten wollen,
                lassen Sie das Popup-Fenster bitte geöffnet.
                <br><br>
                Erlaubt sind CSV-Dateien, die der Vorlage entsprechen:
                <a @click="downloadCsvTemplate()">Import-Vorlage</a>
                <br><br>
                <b>
                  Wichtig: Wenn Sie die CSV-Vorlage in EXCEL bearbeiten,
                  stellen Sie bitte alle Zellen auf das Format "Text".
                  Ansonsten können führende Nullen verloren gehen.
                </b>
                <RbxFileUpload
                  height="100"
                  file-resource="affiliate/csv"
                  :allow-multiple="false"
                  @uploaded="onUpload"
                  @addfile="addFile"
                  @error="onError"
                />
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
